<template>
    <div class="cz2__checkout-item__protectors">
        <h2
            id="cz2-protector-heading"
            class="cz2__checkout-item__name"
        >
            {{$t('PREMIUM_PACKAGING')}}
        </h2>

        <div
            role="radiogroup"
            aria-labelledby="cz2-protector-heading"
            class="cz2__checkout-item__protectors__button__wrapper"
        >
            <label class="cz2__checkout-item__protectors__button">
                <div class="cz2__checkout-item__protectors__button--row">
                    <div
                        :style="{ backgroundImage: `url(${popIcon})` }"
                        class="cz2__checkout-item__protectors__button--image"
                    />

                    <div>
                        {{ $t('NO_PROTECTOR') }}
                    </div>
                </div>

                <span class="cz2__checkout-item__protectors__button__price">
                    + {{ formatPriceValue(0) }}
                </span>

                <input
                    type="radio"
                    name="protector"
                    value="noProtector"
                    :checked="selectedProtector.placeholder"
                    @change="updateCart"
                    class="cz2__checkout-item__protectors__radio"
                >
            </label>

            <label class="cz2__checkout-item__protectors__button">
                <div class="cz2__checkout-item__protectors__button--row">
                    <div
                        :style="{ backgroundImage: `url(${availableProtector.custom.image})` }"
                        class="cz2__checkout-item__protectors__button--image"
                    />

                    <div>
                        {{ addProtectorCopy }}
                    </div>
                </div>

                <span class="cz2__checkout-item__protectors__button__price">
                    + {{ formatPriceValue(protectorPrice) }}
                </span>

                <input
                    type="radio"
                    name="protector"
                    value="protector"
                    :checked="!selectedProtector.placeholder"
                    @change="updateCart"
                    class="cz2__checkout-item__protectors__radio"
                >
            </label>
        </div>
    </div>
</template>

<style lang="scss">
    @import "../style/variables.scss";

    #cz2.cz2 {
        .cz2__checkout-item__protectors {
            .cz2__checkout-item__name {
                margin-bottom: 4px;
            }

            .cz2__checkout-item__protectors__button__wrapper {
                display: flex;
                flex-direction: column;
                gap: 16px;
            }

            .cz2__checkout-item__protectors__button {
                position: relative;

                margin: 0;
                border-radius: 12px;
                padding-right: 16px;
                padding-left: 8px;

                height: 55px;
                width: 100%;

                display: flex;
                justify-content: space-between;
                align-items: center;

                background-color: rgba(255, 255, 255, 0.1);

                @include font(h3-secondary);
                color: white;

                .cz2__checkout-item__protectors__button--row {
                    display: flex;
                    align-items: center;
                }

                .cz2__checkout-item__protectors__button--image {
                    margin-right: 4px;

                    width: 40px;
                    height: 40px;

                    background-size: contain;
                    background-repeat: no-repeat;
                    background-position: center;
                }

                .cz2__checkout-item__protectors__button__price {
                    @include font(h3);
                    white-space: nowrap;
                }

                .cz2__checkout-item__protectors__radio {
                    position: absolute;
                    top: 0;
                    left: 0;
                    margin: 0;
                    padding: 0;

                    width: 100%;
                    height: 59px;

                    appearance: none;
                    outline: none;
                    cursor: pointer;

                    &:checked {
                        &:after {
                            content: '';

                            position: absolute;
                            left: 0;
                            top: -2px;

                            width: 100%;
                            height: 59px;

                            border: 4px solid color(secondaryYellow);
                            border-radius: 12px;
                        }
                    }
                }
            }
        }
    }

    #cz2.cz2.cz2__is-kiosk {
        .cz2__checkout-item__protectors__button__wrapper {
            flex-direction: row;
        }
    }

    #cz2.cz2__is-sb {
        .cz2__checkout-item__protectors {
            .cz2__checkout-item__protectors__button {
                color: #000;
                background-color: #F8EBBB80;
            }
        }
    }
</style>

<script>
    import * as constants from '../constants';

    import { formatPrice } from '../helpers/formatPrice';

    export default {
        computed: {
            viewController() {
                return this.$store.state.customizer.viewController;
            },

            cart() {
                return this.$store.getters.cart;
            },

            selectedProtector() {
                return this.viewController.selectedAtPlacement(constants.PLACEMENT_PROTECTOR);
            },

            placeholderProtector() {
                const protector = this.viewController.findPlacement(constants.PLACEMENT_PROTECTOR);

                return protector.components.find((p) => p.placeholder);
            },

            availableProtector() {
                return this.$store.getters.availableProtector;
            },

            protectorPrice() {
                const component = this.availableProtector;
                let price = 0;

                if (component == null) {
                    return price;
                }

                if (component.price != null) {
                    price = component.price[0].value;
                }

                price = this.viewController.getPrice(this.availableProtector);

                return price;
            },

            popIcon() {
                const mainItem = this.cart.find((item) => item.type === 'main');

                return mainItem.icon[0];
            },

            isKiosk() {
                return this.$store.state.customizer.options.isKiosk;
            },

            addProtectorCopy() {
                return this.isKiosk ? this.$t('ADD_A_POP_PROTECTOR') : this.$t('SHIPS_INSIDE_POP_PROTECTOR');
            },
        },

        methods: {
            updateCart(event) {
                if (event.srcElement.value === 'protector') {
                    this.addProtector();
                } else {
                    this.removeProtector();
                }
            },

            addProtector() {
                if (this.availableProtector) {
                    this.$store.dispatch('log', {
                        level: 'info',
                        message: 'Add protector',
                    });

                    this.$store.dispatch('bumpVersion');

                    this.viewController.updateComponent(constants.PLACEMENT_PROTECTOR, this.availableProtector.code);
                }
            },

            removeProtector() {
                const protector = this.viewController.findPlacement(constants.PLACEMENT_PROTECTOR);

                if (protector) {
                    this.$store.dispatch('log', {
                        level: 'info',
                        message: 'Remove protector',
                    });

                    this.$store.dispatch('bumpVersion');

                    this.viewController.updateComponent(constants.PLACEMENT_PROTECTOR, this.placeholderProtector.code);
                }
            },

            formatPriceValue(price) {
                return formatPrice(this.$store.state, price, 'standard');
            },
        },
    };
</script>
